/**
 * $g
 * 类-全局对象
 *
 * @class
 * @memberof    cx
 * @author      Zhang Fayong
 * @since       2018-04-27
 */
class Global
{
}

/** * @property {Number}            loc             0-英文 1-中文 */
Global.loc = 1

/** * @property {cx.AttFactory}     attFactory      属性对象工厂 */
Global.attFactory = null

/** * @property {Object}            syscfg          系统配置 */
Global.syscfg = null

/** * @property {Object}            user            用户信息 */
Global.user = null

/** * @property {cx.Entities}       entity          实体对象 */
Global.entity = null

/** * @property {cx.Fields}         field           字段对象 */
Global.field = null

/** * @property {cx.Plugins}        plugin          插件对象 */
Global.plugin = null

/** * @property {cx.Funcs}          func            功能对象 */
Global.func = null

/** * @property {cx.FieldCfgs}      fldcfg          字段配置对象 */
Global.fldcfg = null

/** * @property {cx.Services}       service         服务对象 */
Global.service = null

/** * @property {cx.IAccess}        access          权限对象 */
Global.access = null

/** * @property {cx.ProcAssign}     prosAssi        权限对象 */
Global.prosAssi = null

/** * @property {cx.IMessage}       message         消息处理对象 */
Global.message = null

/** * @property {String}            runType         运行模式 */
Global.runType = null

/** * @property {Object}            container       当前的容器 */
Global.container = null

/** * @property {Object}            dlgcfg          对话框设置 */
Global.dlgcfg =
{
  dlgType: 'headerbody',                            //对话框类型
  borderOuter: 0,                                   //外边框粗细
  borderInner: 0,                                   //内边框粗细
  gapBorders: 6                                     //两个边框之间的大小
}

export default Global



// WEBPACK FOOTER //
// ./src/lib/Global.js